import FittingStationFinderConstants from '../../constants/fitting_station_finder_constants';
import StationsActions from '../fitting_station_actions';
import API from '../../../API/api';
import {getCsrfTokenQueryParam} from '../../../utilities/csrf_token_provider';

export const removeStations = () => {
    const stationsPromise = $.Deferred();
    const requestType = 'removeStation';
    StationsActions[requestType] = API.DELETE({
        apiPath: `${FittingStationFinderConstants.FITTING_STATIONS_REMOVE_APIPATH}?${getCsrfTokenQueryParam()}`,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
    });

    StationsActions[requestType].then((stations, message, res) => {
        if (res.status === 200) {
            stationsPromise.resolve(stations);
        } else {
            stationsPromise.reject();
        }
    }).catch(() => {
        stationsPromise.reject();
    });

    return stationsPromise;
};
